<template>
  <v-container class="step">
    <v-row justify="center" class="full-height">
      <v-col class="img-container flex-col">
        <img
          alt="renb renb.jp 生プラセンタ 化粧品"
          class="about-img-center"
          data-aos="zoom-in"
          data-aos-delay="150"
          data-aos-duration="2000"
          data-aos-mirror="true"
          data-aos-once="false"
          contain
          :src="baseUrl + '/media/image/renb_pic12.png'" />
          <p class="img-txt"
          data-aos="zoom-in"
          data-aos-duration="1000"
          >{{$t("_lst_txt_8")}}(30g)</p>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data () {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL
    }
  }
}
</script>

<style scoped>
.img-container {
    width: 100%; /* Chiều rộng của div */
    height: 100%; /* Hoặc có thể là một giá trị cụ thể như 500px */
    display: flex;
    justify-content: center;
    align-items: center;
}
.flex-col {
  flex-direction: column;
}

.about-img-center {
  max-height: 80%;
  object-fit: contain;
}
@media (max-width: 960px) {
  .step {
    height: unset!important;
    scroll-snap-align:unset;
    padding: unset!important;
    margin-top: 20%;
    padding-bottom: 10px!important;
  }
  .img-container {
      height: fit-content!important;
      padding: unset!important;
  }
  .full-height {
    height: unset!important;
    width: 100%;
    padding: unset!important;
  }
  .about-img-center {
      max-height: unset;
      object-fit: cover;
      height: auto;
      width: 100%;
  }
}
@media (max-height:750px) {
  .about-img-center {
      max-height: 100%;
      object-fit: contain;
  }
}
</style>